export function highlightText(
  text: string,
  searchQuery: string
): React.ReactNode {
  if (!searchQuery.trim() || !text) {
    return text;
  }

  const query = searchQuery.toLowerCase();
  const textLower = text.toLowerCase();
  const index = textLower.indexOf(query);

  if (index === -1) {
    return text;
  }

  const before = text.substring(0, index);
  const match = text.substring(index, index + query.length);
  const after = text.substring(index + query.length);

  return (
    <>
      {before}
      <span className="bg-green-01 text-green-05 font-medium px-0.5 rounded">
        {match}
      </span>
      {after}
    </>
  );
}
